import { Checkbox, FormControlLabel, FormGroup, TextField } from '@mui/material'
import { useFormContext } from 'react-hook-form'

export const SpecificationForm = ({ specification, index }) => {
    // доступ к родительскому useForm
    const { register, getValues, setValue } = useFormContext()

    const buildFeatures = () => {
        return specification.features.map((feature, featureIndex) => {
            if (feature.type === 'STRING') {
                return <TextField label={feature.name}
                    {...register(`specifications[${feature.code}]`)} />
            }
            if (feature.type === 'ENUM') {
                return <FormGroup>
                    <div className="m-b-16">{feature.name}:</div>
                    {feature.values.map((value) => {
                        return <FormControlLabel key={value} control={<Checkbox
                            defaultChecked={getValues(`specifications[${feature.code}]`)?.includes(value)}
                            onChange={(e) => {
                                let selectedValues = getValues(`specifications[${feature.code}]`) || []
                                if (selectedValues.includes(value)) {
                                    selectedValues = selectedValues.filter(v => v !== value)
                                } else {
                                    selectedValues = [...selectedValues, value]
                                }

                                console.log('selectedValues: ', selectedValues)
                                setValue(`specifications[${feature.code}]`, selectedValues)
                            }}
                        />} label={value} />
                    })}
                </FormGroup>
            }
            if (feature.type === 'BOOLEAN') {
                return <Checkbox label={feature.name}
                    {...register(`specifications[${index}][features[${featureIndex}]][value]`)} defaultChecked={specification.features[featureIndex].value} />
            }
            return null
        })
    }

    return (
        <div>
            <h3 className="m-b-16">{specification.name}</h3>
            <div className='app-form'>{buildFeatures()}</div>
        </div>
    )
}
